import { useMemo, useState } from 'react'
import ToolCard from '../components/ToolCard'
import { toolCategories, ToolCategorySlug } from '../data/toolCategories'
import { tools } from '../data/tools'

const commonToolIds = new Set([
  'parent-resource-dashboard',
  'pdf-compressor',
  'pdf-rotate',
  'image-compressor',
  'batch-image-compressor',
  'image-watermark',
  'id-photo-cropper',
  'clipboard-share',
  'qr-code-generator',
  'pdf-to-images',
  'json-formatter',
  'text-toolbox'
])

const ToolsPage = () => {
  const [activeCategory, setActiveCategory] = useState<ToolCategorySlug>('common')

  const visibleTools = useMemo(() => {
    if (activeCategory === 'common') return tools.filter(tool => commonToolIds.has(tool.id))
    return tools.filter(tool => tool.categorySlug === activeCategory)
  }, [activeCategory])

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-6xl px-4 py-10 md:py-14">
          <p className="text-sm font-medium text-slate-500">Parentool</p>
          <h1 className="mt-2 text-3xl font-semibold tracking-tight text-slate-950 md:text-4xl">在线工具</h1>
          <p className="mt-3 max-w-2xl text-base leading-7 text-slate-600">
            面向日常办公、图片处理、PDF 处理和文本调试的轻量工具集合。
          </p>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-8 md:py-10">
        <div className="mb-6 flex gap-2 overflow-x-auto pb-1">
          {toolCategories.map(category => (
            <button
              key={category.slug}
              type="button"
              className={`shrink-0 rounded-md border px-4 py-2 text-sm font-medium transition ${
                activeCategory === category.slug
                  ? 'border-slate-950 bg-slate-950 text-white'
                  : 'border-slate-200 bg-white text-slate-700 hover:border-slate-400'
              }`}
              onClick={() => setActiveCategory(category.slug)}
            >
              {category.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {visibleTools.map(tool => <ToolCard key={tool.id} tool={tool} />)}
        </div>
      </main>
    </div>
  )
}

export default ToolsPage
